var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Search = (function (Search) {

        Search.Messages = (function (Messages) {

            Messages.GetSuggestiveResults = function (searchTerm, category) {
                var data = {
                    searchTerm: searchTerm,
                    category: category
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetSuggestiveResults", data);
            };
            Messages.GetSuggestiveResults.className = "Vendd.Search.Messages.GetSuggestiveResults";

            Messages.GetSuggestiveResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetSuggestiveResultsSuccess", data);
            };
            Messages.GetSuggestiveResultsSuccess.className = "Vendd.Search.Messages.GetSuggestiveResultsSuccess";

            Messages.GetSuggestiveResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetSuggestiveResultsFailed", response);
            };
            Messages.GetSuggestiveResultsFailed.className = "Vendd.Search.Messages.GetSuggestiveResultsFailed";

            Messages.GetProductSuggestiveResults = function (searchTerm, maxResults, pageNumber, pageSize) {
                var data = {
                    searchTerm: searchTerm,
                    maxResults: maxResults,
                    pageSize: pageSize,
                    pageNumber: pageNumber
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetProductSuggestiveResults", data);
            };
            Messages.GetProductSuggestiveResults.className = "Vendd.Search.Messages.GetProductSuggestiveResults";

            Messages.GetProductSuggestiveResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetProductSuggestiveResultsSuccess", data);
            };
            Messages.GetProductSuggestiveResultsSuccess.className = "Vendd.Search.Messages.GetProductSuggestiveResultsSuccess";

            Messages.GetProductSuggestiveResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetProductSuggestiveResultsFailed", response);
            };
            Messages.GetProductSuggestiveResultsFailed.className = "Vendd.Search.Messages.GetProductSuggestiveResultsFailed";










            Messages.GetProductSuggestiveElasticResults = function (searchTerm, pageFrom, pageSize, query, path) {
                var data = {
                    searchTerm: searchTerm,
                    pageFrom: pageFrom,
                    pageSize: pageSize,
                    query: query,
                    path: path
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetProductSuggestiveElasticResults", data);
            };

            Messages.GetProductSuggestiveElasticResults.className = "Vendd.Search.Messages.GetProductSuggestiveElasticResults";

            Messages.GetProductSuggestiveResultsElasticSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetProductSuggestiveResultsElasticSuccess", data);
            };
            Messages.GetProductSuggestiveResultsElasticSuccess.className = "Vendd.Search.Messages.GetProductSuggestiveResultsElasticSuccess";

            Messages.GetProductSuggestiveResultsElasticFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Search.Messages.GetProductSuggestiveResultsElasticFailed", response);
            };
            Messages.GetProductSuggestiveResultsElasticFailed.className = "Vendd.Search.Messages.GetProductSuggestiveResultsElasticFailed";

            return Messages;

        })(Search.Messages || {});

        return Search;

    })(Vendd.Search || {});

return Vendd;

})(Vendd || {});